import { Card, Col, Container, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useMemo, useContext } from 'react';
import OrganizationForm from 'components/authenitcation/registration/OrganizationForm';
import AuthContext from 'context/authContext';
import useUpload from 'hooks/useUpload';
import { permissionsKeyMap } from 'routes/permissions/permissionKeys';
import {
  useOrganisation,
  useUpdateOrganisation
} from 'hooks/useOrganisation';

export default function OrganizationSettings() {
  const { organization } = useContext(AuthContext);

  // Use Supabase hooks
  const { organisation, isLoading: dataLoading } = useOrganisation();
  const { updateOrganisationAsync, isUpdating } = useUpdateOrganisation();
  const { upload, deleteFile, loading: uploadLoading } = useUpload();

  const onSubmit = async ({
    logo,
    name,
    country,
    currency,
    address1,
    address2,
    city,
    postCode,
    email,
    charityNumber
  }) => {
    let image = logo;
    try {
      // Upload logo if it's a new file
      if (image && typeof logo !== 'string') {
        // Delete old logo first if it exists
        if (organisation?.logo && organisation.logo.includes('supabase')) {
          try {
            await deleteFile(organisation.logo);
            console.log('Old logo deleted successfully');
          } catch (error) {
            console.error('Failed to delete old logo:', error);
            // Continue anyway - not critical if delete fails
          }
        }

        // Upload new logo
        const profileUrl = await upload(image, 'organisations');
        image = profileUrl;
      }

      // Update organisation in Supabase
      await updateOrganisationAsync({
        id: organization.id,
        data: {
          logo: image,
          organisation_name: name,
          country: country,
          currency_id: currency,
          address_1: address1,
          address_2: address2,
          city: city,
          post_code: postCode,
          organisation_email: email,
          charity_number: charityNumber
        }
      });
    } catch (e) {
      console.error('Update organisation error:', e);
      toast.error('Something went wrong! Please try again later!');
    }
  };
  const initialValues = useMemo(() => {
    if (!organisation) return {};
    return {
      logo: organisation.logo ?? '',
      name: organisation.organisation_name ?? '',
      country: organisation.country ?? '',
      currency: organisation.currency_id ?? '',
      address1: organisation.address_1 ?? '',
      address2: organisation.address_2 ?? '',
      city: organisation.city ?? '',
      postCode: organisation.post_code ?? '',
      email: organisation.organisation_email ?? '',
      charityNumber: organisation.charity_number ?? ''
    };
  }, [organisation]);
  return dataLoading ? (
    <div className="d-flex justify-content-center">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : (
    <Container fluid className="px-0">
      <Row>
        <Col sm={12} md={7}>
          <Card>
            <Card.Body>
              <OrganizationForm
                loading={isUpdating || uploadLoading}
                onSubmit={onSubmit}
                initialValues={initialValues}
                isEdit
                subject={
                  permissionsKeyMap.settings.children.organizationDetails
                }
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
